export default __webpack_public_path__ + "static/media/app-store.e7ad8d39.svg";